/**
 * EBIKO Motion Tune — pause infinite marquees/tickers nobody can see.
 * ───────────────────────────────────────────────────────────────────
 * The brand marquee and news tickers run `... linear infinite` loops. Off-screen
 * (or in a background tab) they still cost compositor work every frame. This
 * observer adds `.ebk-motion-paused` (see ebk-motion-tune.css) while a track is
 * out of view and removes it when it scrolls back in. One IntersectionObserver,
 * no polling, no effect on how the animation looks while visible.
 */
(function () {
  if (window.__ebkMotionTuneInit__) return;
  window.__ebkMotionTuneInit__ = true;

  var SEL = '.ebk-brands__track, .ebk-ticker__inner';

  function tracks() {
    return Array.prototype.slice.call(document.querySelectorAll(SEL));
  }

  // One rule decides everything: paused = off-screen OR tab hidden. The IO
  // callback applies it on every intersection change; visibilitychange
  // re-applies it when the tab's state flips. No early returns — a page
  // LOADED in a background tab must start paused too.
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        en.target.classList.toggle('ebk-motion-paused', !en.isIntersecting || document.hidden);
      });
    }, { rootMargin: '120px' });
  }

  var seen = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  function attach() {
    if (!io) return;
    tracks().forEach(function (el) {
      if (seen) {
        if (seen.has(el)) return;
        seen.add(el);
      }
      io.observe(el);
      if (document.hidden) el.classList.add('ebk-motion-paused');
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      tracks().forEach(function (el) { el.classList.add('ebk-motion-paused'); });
    } else if (io) {
      // Re-observe instead of blanket-unpausing: the fresh observation fires
      // the callback with current intersection, and the single paused-rule
      // (off-screen OR hidden) resolves each track correctly.
      tracks().forEach(function (el) { io.unobserve(el); io.observe(el); });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }

  // Sections can arrive late (Shopify section rendering / AJAX). Watch lightly.
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes || [];
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches(SEL)) || (n.querySelector && n.querySelector(SEL))) {
            attach();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
